import { render, staticRenderFns } from "./SocialPostsListTablePresence.vue?vue&type=template&id=30262abc&scoped=true&"
import script from "./SocialPostsListTablePresence.vue?vue&type=script&lang=js&"
export * from "./SocialPostsListTablePresence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30262abc",
  null
  
)

export default component.exports